"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const react_1 = __importDefault(require("react"));
const lab_1 = require("@mui/lab");
const material_1 = require("@mui/material");
const guidelines_component_1 = require("./partials/guidelines/guidelines.component");
const sidebar_styles_1 = require("./sidebar.styles");
const localization_1 = require("../../../../../localization");
var Tab;
(function (Tab) {
    Tab["Clusters"] = "CLUSTERS";
    Tab["Guidelines"] = "GUIDELINES";
})(Tab || (Tab = {}));
const tabs = [
    { label: Tab.Clusters, disabled: true },
    { label: Tab.Guidelines, disabled: false },
];
const Sidebar = ({ attributeName, nodeTitle, productTreeNodeId }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [activeTab, setActiveTab] = react_1.default.useState(Tab.Guidelines);
    const handleTabChange = (_, newValue) => {
        setActiveTab(newValue);
    };
    return (react_1.default.createElement(lab_1.TabContext, { value: activeTab }, react_1.default.createElement(sidebar_styles_1.StyledSidebar, null, react_1.default.createElement(lab_1.TabList, { onChange: handleTabChange, variant: "fullWidth", "aria-label": "Sidebar navigation tabs" }, tabs.map((tab) => (react_1.default.createElement(material_1.Tab, { key: tab.label, label: t({ key: tab.label }), disabled: tab.disabled, value: tab.label })))), react_1.default.createElement(lab_1.TabPanel, { value: "GUIDELINES" }, react_1.default.createElement(guidelines_component_1.Guidelines, { attributeName: attributeName, nodeTitle: nodeTitle, productTreeNodeId: productTreeNodeId })))));
};
exports.Sidebar = Sidebar;
